import { atom } from 'nanostores'

const STORAGE_KEY = 'birthday_2026_debug_force_ended'

/** Reads the persisted QA toggle, tolerating storage failures. */
export function readDebugForceEnded(): boolean {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

/** QA-only (non-production builds): pretend the event has ended. Persisted
 *  to sessionStorage so a reload still lands in the ended state — the
 *  enter-page auto-jump runs on mount, so flipping the toggle after load
 *  can never exercise that path; a persisted flag + reload can. */
export const $debugForceEnded = atom<boolean>(readDebugForceEnded())

export function setDebugForceEnded(value: boolean): void {
  try {
    if (value) sessionStorage.setItem(STORAGE_KEY, '1')
    else sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // Ignore storage failures (private mode / quota); the toggle still
    // applies to the current page load.
  }
  $debugForceEnded.set(value)
}
